module.exports = __webpack_public_path__ + "assets/ed47bec14b57be6fb7d61fbb83e737ac.mp3";